export default __webpack_public_path__ + "static/media/Vending6.309f7359.png";